export const ITipConfigurationRepositoryType = Symbol('ITipConfigurationRepository');
